/* ===== Подключение компонентов React ===== */
import { useState } from "react";

/* ===== Подключение Локальной Базы Данных ===== */
import { navigation } from "../../../data";

/* ===== Подключение локальных компонентов ===== */
import NavLevel from "./NavLevel";

/* ===== Подключение Стилей ===== */
import styles from "./Nav.module.scss";


function Nav({ onNavigate, resetToken }) {
  return (
    <nav className={styles.nav}>
      <NavLevel items={navigation} level={0} onNavigate={onNavigate} resetToken={resetToken} />
    </nav>
  );
}

export default Nav;
